import {Component, Input, OnInit} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'app-operations-synthesis',
  templateUrl: './operations-synthesis.component.html',
  styleUrls: ['./operations-synthesis.component.scss']
})
export class OperationsSynthesisComponent implements OnInit {
  @Input()
  index: any;

  @Input()
  store: ArrayStore;

  constructor() { }

  ngOnInit(): void {
  }

}
